export const START_TIME_OPTIONS = [
    {
        name: '5 minutes',
        value: 5
    },
    {
        name: '10 minutes',
        value: 10
    },
    {
        name: '15 minutes',
        value: 15,
        default: true
    },
    {
        name: '20 minutes',
        value: 20
    },
    {
        name: '25 minutes',
        value: 25
    },
    {
        name: '30 minutes',
        value: 30
    },
    {
        name: '45 minutes',
        value: 45
    },
    {
        name: '50 minutes',
        value: 50
    },
    {
        name: '60 minutes',
        value: 60
    }
];
